import { Values } from '../../../utils/types';

export const CONTROL = {
  actionSchedule: 'ActionSchedule',
  checkbox: 'Checkbox',
  code: 'Code',
  dateTime: 'DateTime',
  dictionary: 'Dictionary',
  editor: 'Editor',
  email: 'Email',
  emailBuilder: 'EmailBuilder',
  icon: 'Icon',
  id: 'ID',
  json: 'JSON',
  media: 'Media',
  multiSelector: 'MultiSelector',
  notificationCenterTemplate: 'NotificationCenterTemplate',
  number: 'Number',
  radio: 'Radio',
  repeater: 'Repeater',
  ruleBuilder: 'RuleBuilder',
  schedule: 'Schedule',
  select: 'Select',
  switch: 'Switch',
  telephone: 'Telephone',
  text: 'Text',
  textArea: 'TextArea',
  url: 'Url',
} as const;

export type Control = Values<typeof CONTROL>;
